import { createRgFormAPI } from '~/api/core/rgRequest';

const agentsAPI = createRgFormAPI('/get_active_agents_from_lead_manager');

export type Agent = {
  name: string;
  role: string;
  id: string;
};

export async function getAgents(): Promise<{ enabled_users: Agent[] }> {
  try {
    const { data } = await agentsAPI.post();

    return data?.enabled_users || [];
  } catch (e) {
    throw new Error(e);
  }
}
